import { combineReducers } from 'redux';

import app from './app';
import communication from './communication';
import users from './users';
import listUsers from './listUsers';
import manageRole from './manageRole';
import listRoles from './listRoles';

const appReducer = combineReducers({
  app,
  users,
  communication,
  listUsers,
  manageRole,
  listRoles,
});

export default function (state, action = {}) {
  let newState = state;
  if (action.type === 'USER_LOGOUT') {
    newState = undefined;
  }
  return appReducer(newState, action);
}
